import Vue from 'vue'
import Mint from 'mint-ui';
Vue.use(Mint);
import httpService from './utils/service'
import 'normalize.css'
import './assets/less/common.less'
import './assets/less/animate.css'

import App from './App.vue'
import router from './router'
import store from './store'


import './utils/rem'

Vue.directive('focus', {
    inserted: function (el) {
        el.focus()
    }
});
Vue.mixin({
    data() {
        return {
            service: '',
            router: '',
            imgSrc: ''
        }
    },
    created() {
        if (window) {
            this.service = httpService
        }
    }
})
Vue.config.productionTip = false

if (process.env.NODE_ENV == 'development') {
    Vue.config.devtools = true;
} else {
    Vue.config.devtools = false;
}
Vue.use(Mint);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
